import React from "react";
import DeleteButtonSmall from "../buttons/DeleteButtonSmall";
import TableCell from "./TableCell";
import PopupConfirmationWarning from "../dialogs/PopupConfirmationWarning";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {useModal} from "../dialogs/ModalContext";
import PopupConfirmation from "../dialogs/PopupConfirmation";
import PopupConfirmationError from "../dialogs/PopupConfirmationError";

function TableRow(props) {


    const {showModal} = useModal();

    function handleDeleteClick() {
        // if (props.deleteConfirmation) {
        // showModal(PopupConfirmationError, props.deleteConfirmationText, confirmDelete)
        // } else {
        // props.delete_single(props.index)
        // }
        showModal(PopupConfirmationError, "Naozaj chcete vymazať zvolený záznam?", confirmDelete)
    }

    function confirmDelete(confirmed) {
        if (confirmed) {
            props.delete_single(props.index)
        }
    }

    return (
        <tr key={props.index}>
            {props.headers.map((header, ndx) => (
                <TableCell key={ndx} cell={props.row[header['label']]} label={header['label']} links={props.links}
                           textStyle={header['textStyle']}/>
            ))}
            {
                props.actions ? (
                    <td className="fieldWrapper">
                        {
                            <>
                                {props.actions.includes('Delete') && <DeleteButtonSmall onClick={handleDeleteClick}/>}
                            </>
                        }
                    </td>
                ) : null
            }
        </tr>
    )
}

export default TableRow
